import { render, staticRenderFns } from "./ReferralIcon.vue?vue&type=template&id=2b0e1390&scoped=true&"
import script from "./ReferralIcon.vue?vue&type=script&lang=ts&"
export * from "./ReferralIcon.vue?vue&type=script&lang=ts&"
import style0 from "./ReferralIcon.vue?vue&type=style&index=0&id=2b0e1390&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0e1390",
  null
  
)

export default component.exports